import React, { useState } from "react";
import styled, { createGlobalStyle } from "styled-components/macro";
import { GlobalStyleProps } from "../types/styles";
import { RouteType } from "../types/routes";
import Sidebar from "../components/Sidebar";
import Header from "../components/AppBar";
// import Footer from "../components/Footer";
// import Settings from "../components/Settings";

import { spacing } from "@material-ui/system";
import {
  Hidden,
  CssBaseline,
  Paper as MuiPaper,
  withWidth,
} from "@material-ui/core";


const drawerWidth = 18;

const GlobalStyle = createGlobalStyle<GlobalStyleProps>`
  html,
  body,
  #root {
    height: 100%;
  }
  body {
    background: ${(props) => props.theme.palette.background.default};
  }
  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`;

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`;

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up("md")} {
    width: auto;
    flex-shrink: 0;
  }
`;

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  max-width: 100%;
`;

const Paper = styled(MuiPaper)(spacing);

type Props = {
  draweropen: number
}

const MainContent = styled(Paper)<Props>`
  // flex: 1;
  margin-top: 70px;
  overflow: hidden;
  background: ${(props) => props.theme.palette.background.default};
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  };
  margin-left: ${(props) => props.draweropen ? "60px" : "0px"};
  & .stepper-content-wrapper {
    left: ${(props) => props.draweropen ? "0px" : "0px"};
    right: ${(props) => props.draweropen ? "60px" : "0px"};
    padding-left: ${(props) => props.draweropen ? "70px" : "10px"};
  }
  ${(props) => props.theme.breakpoints.down("sm")} {
    margin-top: 60px;
    & > div {
      padding: 20px;
    }
  };
  // transition: margin-left .2s ease-out;
  transition: margin-left 0.${(props) => 
    props.theme.transitions.duration.enteringScreen}s
    ${(props) => props.theme.transitions.easing.sharp};
  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  };
`;

type DashboardPropsType = {
  routes: Array<RouteType>;
  width: "md" | "xs" | "sm" | "lg" | "xl";
};

const Dashboard: React.FC<DashboardPropsType> = ({
  children,
  routes,
  width,
}) => {
  const drawerState = localStorage.getItem('drawerOpen');
  const storedOpen = drawerState? JSON.parse(drawerState) : true;
  const [drawerOpen, setDrawerOpen] = React.useState(storedOpen);

  const handleDrawerToggle = () => {    
    localStorage.setItem('drawerOpen', String(!drawerOpen));
    setDrawerOpen(!drawerOpen);
  };

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Drawer>
        <Hidden mdUp implementation="js">
          <Sidebar
            routes={routes}
            PaperProps={{ style: { width: `auto` } }}
            variant="temporary"
            drawerOpen={drawerOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Hidden>
        <Hidden smDown implementation="css">
          <Sidebar
            routes={routes}
            PaperProps={{ style: { width: `${drawerWidth}vw`} }}
            drawerOpen={drawerOpen}
            handleDrawerToggle={handleDrawerToggle}
          />
        </Hidden>
      </Drawer>
      <AppContent>
        {/* <Header onDrawerToggle={handleDrawerToggle}/> */}
        <MainContent className="MainContent" draweropen={drawerOpen ? 1 : 0}>
          {children}
        </MainContent>
        {/* <Footer /> */}
      </AppContent>
    </Root>
  );
};

export default withWidth()(Dashboard);
